import axios from "axios";
import { defaultHeader } from "../../DefaultConfig";
import { AuthenticationURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function forgotPasswordRequest(email: string){
    ShowAwaiting();
    var res = await axios.post(
        AuthenticationURL + "api/password/forgot",
        {
            email: email,
        },
        {
            withCredentials: true
        }
    );
    HideAwaiting();
    return res.data;
}

export async function confirmUpdatePassword(password: string, confirmPassword: string){
    ShowAwaiting();
    var res = await axios.put(
        AuthenticationURL + "api/password/forgot/confirm",
        {
            currentPassword: password,
            newPassword: confirmPassword
        },
        {
            withCredentials: true
        }
    );
    HideAwaiting();
    return res.data;
}